import React, { useState } from "react";
import { Tabs, Tab, Box, Paper } from "@mui/material";

const TabIndex = ({ tabsContent, onChange }) => {
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (event, newIndex) => {
    setActiveTab(newIndex);
    if (onChange) {
      onChange(tabsContent[newIndex]);
    }
  };

  return (
    <Paper elevation={3} sx={{ width: "100%", p: 2 }}>
      <Tabs
        value={activeTab}
        onChange={handleTabChange}
        variant="fullWidth"
        indicatorColor="primary"
        textColor="primary"
      >
        {tabsContent.map((tab, index) => (
          <Tab key={index} label={tab.label} />
        ))}
      </Tabs>
      <Box p={2} sx={{ minHeight: "100px" }}>
        {tabsContent[activeTab] && tabsContent[activeTab].content}
      </Box>
    </Paper>
  );
};

export default TabIndex;
